import { TypographyStylesProvider, Code, Image } from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconApps,
  IconInfoCircle,
  IconPlugConnected,
  IconUsers,
} from "@tabler/icons-react";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const NOSTR_GET_PRIVATE_KEY_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Each of your Rizful Node nodes has a private key that can uniquely
      identify you on the decentralized web.
    </p>
    <p>
      You should only use your Nostr private key with apps and websites that you
      trust.
    </p>

    <p>1. Use the Node Info button. </p>

    <DocsButton
      ariaLabel="node info"
      text="Node Info"
      leftSection={<IconInfoCircle />}
    />
    <p>2. Copy your Nostr private key. </p>
    <SimpleImage
      h={500}
      // w={356}
      src="docs_images/get-nostr-private-key.png"
    />
  </TypographyStylesProvider>
);
